<template>
    <el-card class="page_card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>权限规则</span>
        </div>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" ref="selectForm" :model="selectForm">
                    <el-form-item label="模块:">
                        <el-radio-group v-model="selectForm.type" :disabled="is_post">
                            <el-radio-button v-for="model of models" :label="model.id" :key="model.id">{{model.text}}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-select v-model="selectForm.isValid" placeholder="请选择" style="width: 80px;">
                            <el-option
                                    v-for="item in isValid_group"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" plain @click="select()" :loading="is_post"><i class="el-icon-search" /> 查询</el-button>
                        <el-button plain @click="refresh()" :loading="is_post"><i class="el-icon-refresh" /> 重置</el-button>
                        <el-button plain @click="addBtn()" type="success">+ 新增顶层权限</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table empty-text="暂无数据"
                          ref="table"
                          row-key="id"
                          :loading="is_post"
                          :data="data"
                          tooltip-effect="dark"
                          style="width: 100%"
                          >
                    <el-table-column label="权限key" width="260">
                        <template slot-scope="scope">
                            <span v-if="scope.row.name.indexOf(':') > -1">
                                <svg-icon style="font-size: 1.2em;font-weight: 700;" :icon-class="scope.row.name.split(':')[0]" />  <span class="primary_text" style="font-size: 16px;display: inline-block;margin-left: 5px">{{scope.row.name.split(':')[1]}}</span>
                            </span>
                            <span v-else>
                                <span class="primary_text" style="font-size: 16px;display: inline-block;margin-left: 5px">{{scope.row.name}}</span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="权限名称">
                        <template slot-scope="scope">
                            {{scope.row.displayName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="权限说明">
                        <template slot-scope="scope">
                            {{scope.row.description}}
                        </template>
                    </el-table-column>
                    <el-table-column label="权限模块">
                        <template slot-scope="scope">
                            <el-link type="primary" :underline="false" v-if="scope.row.type == 0">后台</el-link>
                            <el-link type="success" :underline="false" v-if="scope.row.type == 2">Api</el-link>
                            <el-link type="warning" :underline="false" v-if="scope.row.type == 1">App</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <el-link
                                    v-if="scope.row.isValid == 1 && scope.row.isDelete != 1"
                                    size="mini"
                                    type="success"
                                    :underline="false"
                                    :disabled="is_post"
                            >
                                启用
                            </el-link>
                            <el-link
                                    size="mini"
                                    type="warning"
                                    :underline="false"
                                    :disabled="is_post"
                                    v-if="scope.row.isValid == 0 && scope.row.isDelete != 1"
                            >
                                禁用
                            </el-link>
                            <el-link type="danger" size="mini" :underline="false" v-if="scope.row.isDelete == 1">已删除</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                type="success"
                                plain
                                @click="addBtnByItem(scope.row)"
                            >
                                +
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="warning"
                                    plain
                                    @click="editBtn(scope.row)"
                            >
                                <svg-icon icon-class="change" />
                            </el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    :loading="is_post"
                                    @click="del(scope.row)"
                            >
                                <svg-icon icon-class="del" />
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>


        <el-dialog
            title="添加权限"
            :visible.sync="add_dialog"
            width="30%"
        >
            <el-form ref="addForm" :rules="addRules" :model="addForm" label-width="100px">
                <el-form-item label="权限Key:" prop="name">
                    <el-input v-model="addForm.name" placeholder="权限key" :maxlength="40" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="模块:" v-if="is_show_type">
                    <el-radio-group v-model="addForm.type">
                        <el-radio-button label="0">后台</el-radio-button>
                        <el-radio-button label="1">App</el-radio-button>
                        <el-radio-button label="2">Api</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="权限类型:" v-if="addForm.type == 0">
                    <el-radio-group v-model="type">
                        <el-radio-button label="view">页面</el-radio-button>
                        <el-radio-button label="btn">按钮</el-radio-button>
                        <el-radio-button label="block">自定义</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="权限名称:" prop="displayName">
                    <el-input v-model="addForm.displayName" placeholder="权限名称" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="上级权限">
                    <el-cascader
                        :options="data"
                        v-model="addForm.parentId"
                        @change="addSelectChange"
                        :props="{ checkStrictly: true ,label:'displayName',value:'id'}"
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="权限说明:">
                    <el-input v-model="addForm.description" placeholder="权限说明" type="textarea" :maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否启用:">
                    <el-switch
                        style="position: relative;top: 4px;display: block"
                        v-model="addForm.isValid"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="addSubmit()" :loading="is_post">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="编辑权限" :visible.sync="edit_dialog" width="30%">
            <el-form ref="editForm" :rules="addRules" :model="editForm" label-width="100px">
                <el-form-item label="权限Key:" prop="name">
                    <el-input v-model="editForm.name" placeholder="权限key" :maxlength="40" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="模块:" v-if="is_show_type">
                    <el-radio-group v-model="editForm.type">
                        <el-radio-button label="0">后台</el-radio-button>
                        <el-radio-button label="1">App</el-radio-button>
                        <el-radio-button label="2">Api</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="权限类型:" v-if="editForm.type == 0">
                    <el-radio-group v-model="editType">
                        <el-radio-button label="view">页面</el-radio-button>
                        <el-radio-button label="btn">按钮</el-radio-button>
                        <el-radio-button label="block">自定义</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="权限名称:" prop="displayName">
                    <el-input v-model="editForm.displayName" placeholder="权限名称" :maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="上级权限">
                    <el-cascader
                        @change="editSelectChange"
                        :options="data"
                        v-model="editForm.parentId"
                        :props="{ checkStrictly: true ,label:'displayName',value:'id'}"
                        clearable></el-cascader>
                </el-form-item>
                <el-form-item label="权限说明:">
                    <el-input v-model="editForm.description" :maxlength="50" show-word-limit placeholder="权限说明" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="是否启用:">
                    <el-switch
                        style="position: relative;top: 4px;display: block"
                        v-model="editForm.isValid"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="warning" plain @click="editSubmit()" :loading="is_post">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </el-card>
</template>

<script>
    import {deepClone} from '@/utils'
    import request from "@/utils/request"
    import {stringTrim} from '@/utils/elvalid'

    export default {
        name: 'auth_permission',
        data() {
            return {
                models:[
                    { id:'all', text:"全部"},
                    { id:0, text:"后台"},
                    { id:1, text:"APP"},
                    { id:2, text:"Api"}
                ],
                user_groups:[
                    {
                        id:"all",displayName:"全部"
                    }
                ],
                isValid_group:[
                    {
                        id:"all",name:"全部"
                    },
                    {
                        id:1,name:"启用"
                    },
                    {
                        id:0,name:"禁用"
                    }
                ],
                selectForm:{
                    type:"all",
                    isValid:"all",
                },
                treeData:[],
                data:[],
                is_post:false,
                is_ok:false,
                add_dialog:false,
                addForm:{
                    name:"",
                    displayName:"",
                    description:"",
                    isValid:true,
                    parentId:0,
                    type:0
                },
                type:"view",
                editType:"",
                addRules:{
                    name:[
                        { required: true, message: '请输入权限key', trigger: 'blur' },
                        { validator: stringTrim, trigger: 'blur' },
                        { pattern:/^[0-9a-z-_]{1,50}$/, message: '唯一且只支持小写字母或数字或-或_', trigger: 'blur' }
                    ],
                    displayName:[
                        { required: true, message: '请输入权限名称', trigger: 'blur' },
                        { validator: stringTrim, trigger: 'blur' },
                        { pattern:/^.{1,20}$/, message: '最多输入20个字符', trigger: 'blur' }
                    ]
                },
                edit_dialog:false,
                editForm:{
                    id:0,
                    name:"",
                    displayName:"",
                    description:"",
                    isValid:true,
                    parentId:0,
                    type:0
                },
                is_show_type:true,
            }
        },
        watch:{

        },
        methods: {
            addSelectChange(item){
                let parentId = 0;
                if(item.length){
                    parentId = item[item.length - 1];
                }
                let it = this.selectTree(parentId,this.data);
                if(parentId == 0){
                    this.is_show_type = true;
                }else{
                    this.is_show_type = false;
                    this.addForm.type = it.type;
                }
            },
            editSelectChange(item){
                let parentId = 0;
                if(item.length){
                    parentId = item[item.length - 1];
                }
                let it = this.selectTree(parentId,this.data);
                if(parentId == 0){
                    this.is_show_type = true;
                }else{
                    this.is_show_type = false;
                    this.editForm.type = it.type;
                }
            },
            addBtn(){
                this.addForm.parentId = 0;
                this.is_show_type = true;
                this.add_dialog = true;
            },
            addBtnByItem(item){
                this.is_show_type = false;
                this.addForm.type = item.type;
                this.addForm.parentId = item.id;
                this.add_dialog = true;
            },
            editBtn(item){
                this.editForm.id = item.id;
                this.editForm.parentId = item.parentId;
                if(item.name.indexOf(":") > -1){
                    this.editForm.name = item.name.split(":")[1];
                    this.editType = item.name.split(":")[0];
                }else{
                    this.editForm.name = item.name;
                }
                this.is_show_type = false;
                this.editForm.type = item.type;
                this.editForm.displayName = item.displayName;
                this.editForm.description = item.description;
                this.edit_dialog = true;
            },
            refresh(){
                this.$refs["selectForm"].resetFields();
                this.selectForm = {
                    type:"all",
                    isValid:"all"
                };
                this.getData();
            },
            select(){
                this.getData();
            },
            makeTree(list,num = 0,data = []){
                for(let i = 0;i<list.length;i++){
                    if(num == 0){
                        if(list[i].parentId == 0){
                            let item = list.splice(i,1)[0];
                            item.children = [];
                            data.push(item);
                            i--;
                        }
                    }else{
                        let item = this.selectTree(list[i].parentId,data)
                        if(item){
                            let it = list.splice(i,1)[0];
                            it.children = [];
                            // if(typeof item.children == "undefined"){
                            //     item.children = [];
                            // }
                            item.children.push(it);
                            i--;
                        }
                    }
                }
                if(list.length == 0 || num > 10){
                    return data;
                }else{
                    return this.makeTree(list,++num,data);
                }
            },
            selectTree(id,list){
                let res = null;
                for(let item of list){
                    if(item.id == id){
                        return item;
                    }else if(item.children && item.children.length > 0){
                        res = this.selectTree(id,item.children);
                        if(res){
                            return res;
                        }
                    }
                }
                return res;
            },
            getData(is_init = 0){
                if(!is_init){
                    this.is_post = true;
                }
                request.post("permission/list",this.selectForm).then(res=>{
                    this.data = this.makeTree(res.data);
                    if(!is_init){
                        this.is_post = false;
                    }else{
                        this.is_ok = true;
                    }
                }).catch(err=>{
                    if(!is_init){
                        this.is_post = false;
                    }else{
                        this.is_ok = true;
                    }
                });
            },
            addSubmit(){
                this.$refs["addForm"].validate(valid=>{
                    if(!valid)return false;
                    this.is_post = true;
                    let data = deepClone(this.addForm);
                    if(data.type == 0){
                        data.name = this.type+":"+this.addForm.name;
                    }else if(this.addForm.type == 2){
                        data.name = "api:"+this.addForm.name;
                    }
                    if(typeof this.addForm.parentId == "object"){
                        data.parentId = this.addForm.parentId.length == 0?0:this.addForm.parentId[0];
                    }else if(typeof this.addForm.parentId == "number"){
                        data.parentId = this.addForm.parentId;
                    }
                    request.post("permission/create",data).then(res=>{
                        let item = this.selectTree(res.data.parentId,this.data);
                        res.data.children = [];
                        if(item){
                            if(typeof item.children == "undefined"){
                                item.children = [];
                            }
                            item.children.push(res.data);
                        }else{
                            this.data.push(res.data);
                        }
                        this.$refs["addForm"].resetFields();
                        this.add_dialog = false;
                        this.$message.success("添加权限成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                        console.log(err);
                    });
                });
            },
            del(item){
                this.$confirm('此操作将永久删除该权限, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    this.is_post = true;
                    request.post("permission/delete",{id:item.id}).then(res=>{
                        let parent = this.selectTree(item.parentId,this.data);
                        if(item.parentId && parent && parent.children.length > 0){
                            for(let i = 0;i<parent.children.length;i++){
                                if(parent.children[i].id == item.id){
                                    parent.children.splice(i,1);
                                    break;
                                }
                            }
                        }else{
                            for(let i=0;i<this.data.length;i++){
                                if(this.data[i].id == item.id){
                                    this.data.splice(i,1);
                                    break;
                                }
                            }
                        }
                        this.$message.success("删除权限成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            editSubmit(){
                this.$refs["editForm"].validate(valid=>{
                    if(!valid) return false;
                    this.is_post = true;
                    let data = deepClone(this.editForm);
                    if(data.type == 0){
                        data.name = this.editType+":"+this.editForm.name;
                    }else if(this.editForm.type == 2){
                        data.name = "api:"+this.editForm.name;
                    }
                    if(typeof this.editForm.parentId == "object"){
                        data.parentId = this.editForm.parentId.length == 0?0:this.editForm.parentId[0];
                    }else if(typeof this.editForm.parentId == "number"){
                        data.parentId = this.editForm.parentId;
                    }
                    request.post("permission/edit",data).then(res=>{
                        let item = this.selectTree(data.id,this.data);
                        if(item.parentId != res.data.parentId){
                            let old_parent = this.selectTree(item.parentId,this.data);
                            let new_parent = this.selectTree(res.data.parentId,this.data);
                            old_parent.children.map((n,i)=>{
                                if(n.id == data.id) {
                                    new_parent.children.push(old_parent.children.splice(i,1)[0]);
                                }
                            });
                        }
                        for(let k of Object.keys(item)){
                            if(typeof res.data[k] != "undefined") item[k] = res.data[k];
                        }
                        this.$refs["editForm"].resetFields();
                        this.edit_dialog = false;
                        this.$message.success("修改权限成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            }
        },
        created() {
            this.getData(1);
        }
    }
</script>

<style scoped>

</style>
